import SectionWrapper from '@/components/atoms/SectionWrapper';
import RequestsTable from '@/components/reports/users/RequestsTable';
import { Stats } from '@/components/reports/users/Stats';
import PeriodSelect from '@/components/reports/SharedComponents/PeriodSelect';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetUsersFilters } from '@/store/slices/reportFiltersSlice';
import { setSearch, setPage, setModalId } from '@/store/slices/publicSlice';

export default function UsersReport() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetUsersFilters());
      dispatch(setSearch({ key: 'usersReportSearch', value: '' }));
      dispatch(setPage(0));
      dispatch(setModalId(null));
    };
  }, [dispatch]);

  return (
    <SectionWrapper
      title={t('reports.users.userRequests', 'User requests')}
      desc={t(
        'reports.users.userRequestsDesc',
        'A unified list of all requests submitted by users, allowing admins to review, manage, and take necessary actions efficiently.'
      )}
      actions={<PeriodSelect />}
    >
      <div className="space-y-6">
        <Stats />

        <RequestsTable />
      </div>
    </SectionWrapper>
  );
}
